<template>
  <div>
    <h1 v-text="translate.trans('app_reports.title') + ' (' + listReports.length + ')'"></h1>
    <DateRangePicker
      v-model="dateRange"
      opens="right"
      :locale-data="locale"
      time-picker
      time-picker24hour
    ></DateRangePicker>
    <div class="d-flex">
      <BFormSelect
        v-model="selectedReason"
        :options="options"
      ></BFormSelect>
      <BFormInput
        v-model="searchName"
        class="ml-3"
        placeholder="Search user name"
      ></BFormInput>
      <BFormInput
      v-model="searchMemory"
        class="ml-3"
        placeholder="Search memory name"
      ></BFormInput>
    </div>

    <div></div>
    <div class="row mt-3">
      <div class="col-lg-12 col-md-8 col-sm-12 col-12 pb-5">
        <div class="orders">
          <div  id="scroll-main-content" class="box table-area table-products overflow-x">
            <BTable
              sort-icon-left
              responsive="sm"
              :items="listReportsToSort"
              :fields="fields"
              sort-by="report_date"
              :sort-desc="true"
            >
              <template v-slot:cell(report_user_first_name)="data">
                <div class="p-2 d-flex">
                  <p
                    class="text-username"
                    :title="data.item.report_user_first_name"
                    @click="goToPageUserDetail(data.item.report_user_id)"
                  >
                    {{ data.item.report_user_first_name }}
                  </p>
                </div>
              </template>

              <template v-slot:cell(user_has_been_report_first_name)="data">
                <div class="p-2 d-flex">
                  <p
                    class="text-username"
                    :title="data.item.user_has_been_report_first_name"
                    @click="goToPageUserDetail(data.item.reported_user_id)"
                  >
                    {{ data.item.user_has_been_report_first_name }}
                  </p>
                </div>
              </template>

              <template v-slot:cell(remove_content)="data">
                <div class="p-2">
                  <button
                    title="Remove"
                    class="remove-x-button"
                    @click="removeContent(data.item)"
                  ></button>
                </div>
              </template>
              <template v-slot:cell(view_memory)="data">
                <div class="p-1">
                  <button
                    title="ViewMemory"
                    class="view-button"
                    @click="viewMemory(data.item)"
                  ></button>
                </div>
              </template>   
              <template v-slot:cell(actions)="data">
                <div class="p-2">
                  <button
                    title="Remove"
                    class="remove-button"
                    @click="removeReport(data.item)"
                  ></button>
                </div>
              </template>              
            </BTable>
          </div>
        </div>
      </div>
    </div>
    <BModal id="modal-center" v-model="userInfoModal.isOpen" centered :title="`User Information`" size="lg">
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.details.full_name")}}</span>: {{userInfoModal.user.first_name + " " + userInfoModal.user.last_name}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.details.email")}}</span>: {{userInfoModal.user.email}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.details.status")}}</span>: {{userInfoModal.user.is_active === 1 ? translate.trans("users.details.active") : translate.trans("users.details.inActive")}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.details.registration_data")}}</span>: {{this.$moment(userInfoModal.user.registration_date).format('DD/MM/YYYY')}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.details.heritage_timeline")}}</span>: {{userInfoModal.user.heritage_timeline_email}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.details.heritage_safebox")}}</span>: {{userInfoModal.user.heritage_safe_box_email}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.statistic.total_memo")}}</span>: {{userInfoModal.user.number_of_memories}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.statistic.total_safe_memo")}}</span>: {{userInfoModal.user.number_of_safe_memories}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.statistic.total_space_memo")}}</span>: {{userInfoModal.user.number_of_space_memories}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.statistic.total_ghost_memo")}}</span>: {{userInfoModal.user.number_of_ghost_memories}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.statistic.total_share_memo")}}</span>: {{userInfoModal.user.number_of_shared_memories}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.statistic.total_report_to_user")}}</span>: {{userInfoModal.user.number_of_user_has_been_reported}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.statistic.total_repost_from_user")}}</span>: {{userInfoModal.user.number_of_user_reported_other_users}}
      </p>
      <p class="row-info">
        <span class="text-label">{{translate.trans("users.statistic.total_complete_questionair")}}</span>: {{userInfoModal.user.is_complete}}
      </p>
      
      <template v-slot:modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <BButton variant="primary" size="sm" @click="closeUserInfoModal">
            Close
          </BButton>
        </div>
      </template>
    </BModal>
  </div>
</template>

<script>
import {
  BTable,
  // BFormDatepicker,
  // BInputGroup,
  BFormInput,
  // BInputGroupAppend,
  BModal,
  BFormSelect,
} from "bootstrap-vue";
import DateRangePicker from "vue2-daterange-picker";
import DibbleTranslation from "../../translation/translation";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DibbleAPI from '../../api';
import DibbleJS from '../../dibble';
export default {
  name: "AppReportsPage",
  components: {
    BFormSelect,
    BTable,
    BModal,
    // BFormDatepicker,
    // BInputGroup,
    BFormInput,
    // BInputGroupAppend,
    DateRangePicker
  },
  data() {
    return {
      translate: DibbleTranslation,
      fields: [
        {
          key: "report_created_date",
          label: "Date and time of report",
          sortable: true,
          formatter: (value) => {
            return value ? this.$moment(value).format("DD/MM/YY") : "";
          },
        },
        { 
          key: "report_user_first_name", label: "User name reported", sortable: true },
        { key: "report_reason_text", label: "Report reason", sortable: true },
        { key: "report_explanation", label: "Explanation", sortable: true },
        {
          key: "memory_title",
          label: "Memory Name",
          sortable: true,
        },
        {
          key: "user_has_been_report_first_name",
          label: "User name who has been reported",
          sortable: true,
        },
        {
          key: "report_status_text",
          label: "Report Status",
          sortable: true,
        },
        {
          key: "remove_content",
          label: "Remove Content"
        },
        {
          key: "view_memory",
          label: "View Memo"
        },
        { key: "actions", label: "Actions" },
      ],
      listReports: [],
      listReportsToSort: [],
      dateRange: {
        startDate: null,
        endDate: null,
      },
      locale: {
        format: "dd/mm/yy HH:MM",
      },
      selectedReason: null,
      options: [
        { value: null, text: "Please select an report reason" }      
      ],
      searchName: "",
      searchMemory: "",
      userInfoModal: {
        isOpen: false,
        user: {}
      }
    };
  },
  watch: {
    dateRange(value) {
      this.handleSearch(
        value,
        this.selectedReason,
        this.searchName,
        this.searchMemory
      );
    },
    selectedReason(value) {
      this.handleSearch(
        this.dateRange,
        value,
        this.searchName,
        this.searchMemory
      );
    },
    searchName(value) {
      this.handleSearch(
        this.dateRange,
        this.selectedReason,
        value,
        this.searchMemory
      );
    },
    searchMemory(value) {
      this.handleSearch(
        this.dateRange,
        this.selectedReason,
        this.searchName,
        value
      );
    },
  },
  mounted() {
    this.getListReports();
    this.getReportReasons();
    const scrollContent = document.getElementById('scroll-main-content')
      scrollContent.style.height = window.innerHeight*0.75 +  "px"
  },
  methods: {
    getListReports() {      
      const rq = {
        "#request": DibbleAPI.api.report.gets
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(
        rq,
        (data) => {
          if (DibbleAPI.isResponseSuccess(data)) {
            DibbleJS.hideLoader()
            this.listReports = data.reports
            this.listReportsToSort = [...this.listReports];
          }
        },
        true
      )     
    },
    getReportReasons () {
      const rq = {
        "#request": DibbleAPI.api.report.getInfo
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(
        rq,
        (data) => {
          DibbleJS.hideLoader()
          if (DibbleAPI.isResponseSuccess(data)) {
            const reasons = [
              { value: null, text: "Please select an report reason" }
            ]
            for (const key in data.report_reasons) {
              reasons.push({
                value: data.report_reasons[key], text: data.report_reasons[key]
              })
            }
            this.options = reasons
          }
        },
        true
      )    
    },
    removeContent(data){
      DibbleJS.confirmBox(this.translate.trans("app_reports.confirmDelete"), () => {
        console.log("removeContent" + JSON.stringify(data))
        const rq = {
          "#request": DibbleAPI.api.report.deleteReportedMemory,
          report_id: data.report_id
        }
        DibbleJS.showLoader()
        DibbleJS.callApiRequest(rq, (data) => {
          DibbleJS.hideLoader()
          if (DibbleAPI.isResponseSuccess(data)) {
            this.getListReports()
          }
        }, true)
      })
    },
    viewMemory(data){
      console.log("viewMemory" + JSON.stringify(data))
      const memoId = data.memory_id;
      console.log("memoId " + memoId)
      // self.$router.replace("/MemoDetails")
      // this.$router.push('/memo/' + memoId);
      const routeNewTab = this.$router.resolve({ path: '/memo/' + memoId });
      window.open(routeNewTab.href);
    },
    removeReport(data){
      console.log("removeContent" + JSON.stringify(data))
      const rq = {
        "#request": DibbleAPI.api.report.changeStatus,
        report_id: data.report_id,
        report_status: 4
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(rq, (data) => {
        DibbleJS.hideLoader()
        if (DibbleAPI.isResponseSuccess(data)) {
          this.getListReports()
        }
      }, true)
    },
    goToPageUserDetail(idUser) {
      console.log("goToPageUserDetail: " + JSON.stringify(idUser))
      const rq = {
        "#request" : DibbleAPI.api.getUser,
        user_id: idUser
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(rq,
        (data) => {
          DibbleJS.hideLoader()
          if (DibbleAPI.isResponseSuccess(data)) {
            this.userInfoModal.user = data.user
            this.userInfoModal.isOpen = true
          } else {
            DibbleJS.toastErrorMessage(data.message)
          }
        }
      )      
    },
    closeUserInfoModal () {
      this.userInfoModal.isOpen = false
    },
    handleSearch(date, selectedReason, searchName, searchMemory) {
      const timeStart = new Date(date.startDate).getTime();
      const timeEnd = new Date(date.endDate).getTime();
      // eslint-disable-next-line array-callback-return
      this.listReportsToSort = this.listReports.filter((el) => {
        const time = new Date(el.report_created_date).getTime();
        const conditionTime =
          timeEnd && timeStart ? timeStart < time && time < timeEnd : true;
        const conditionReport = selectedReason
          ? el.report_reason_text.toLowerCase() === selectedReason.toLowerCase()
          : true;
        if (
          conditionTime &&
          conditionReport &&
          el.report_user_first_name.includes(searchName) &&
          el.memory_title.includes(searchMemory)
        ) {
          return el;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.text-username {
  cursor: pointer;
  color: blue;
  &:hover {
    font-style: italic;
  }
}
.row-info {
  margin-bottom: 5px
}
.text-label {
  width: 40%;
  display: inline-block;
}
</style>
